var leftPanel = $('#div-gpt-ad-Panel-Ad-1');
var footer = $('footer');
var hideAds = false;

var hero = $('.hero');

//console.log("hero.length = " + hero.length);

var adTopStartPos = 420;
var adTopfixedPos = 100;

var triggerScrollTopPos = 280;

var pathname = window.location.pathname;
var venueheader = $('.featured-venues-header');
var jumplinks = $('.jump-links');

if (pathname.toLowerCase().indexOf('meeting-event-venues') != -1 && (venueheader.length > 0 || jumplinks.length > 0) ) {

    console.log("Yes, this is a venue page.");

    var pageelem;
    var adTopPad = 0;
    var scrollTopPad = 0;

    if (venueheader.length > 0) {
        pageelem = venueheader;
        adTopPad = 30;
        scrollTopPad = 65;
    } else {
        pageelem = jumplinks;
        adTopPad = 120;
        scrollTopPad = 20;
        adTopfixedPos = 160;
    }
    //console.log("========> venueheader offset top = " + parseInt(pageelem.offset().top, 10));
    //console.log("========> venueheader position top = " + parseInt($('.featured-venues-header').position().top, 10));


    adTopStartPos = parseInt(pageelem.offset().top + adTopPad, 10);
    triggerScrollTopPos = parseInt(pageelem.offset().top - scrollTopPad, 10);
    $('.ad-sidepanel').css({
        top: adTopStartPos,
    });

} else if (hero.length > 0) {

    adTopStartPos = 1200;
    triggerScrollTopPos = 1090;
    $('.ad-sidepanel').css({
        top: adTopStartPos,
    });
    //console.log("hero.length = " + hero.length);

}

$(document).on("scroll", function () {

    if (leftPanel.length > 0) {
        var currentScrollTopPos = $(document).scrollTop()
        var pageBottom = currentScrollTopPos + $(window).height()

        if ((currentScrollTopPos > triggerScrollTopPos && parseInt($(leftPanel).css('top'), 10) == adTopStartPos) || parseInt($(leftPanel.offset().top, 10) <= adTopfixedPos + 1)) {

            //console.log("Scroll up condition met");

            $('.ad-sidepanel').css({
                top: adTopfixedPos,
                position: "fixed"
            });

        }

        if (currentScrollTopPos < triggerScrollTopPos && parseInt($(leftPanel).css('top'), 10) == adTopfixedPos) {

            //console.log("Scroll down condition met");

            $('.ad-sidepanel').css({
                top: adTopStartPos,
                position: "absolute"
            });

        }

        var leftPanelBottom = parseInt(leftPanel.css('top'), 10) + parseInt(leftPanel.height(), 10) + 20;
        var footerTop = footer.offset().top;
        var footerWindowTop = footer.offset().top - currentScrollTopPos;

        if (footerTop < pageBottom && footerWindowTop < leftPanelBottom && hideAds == false) {

            $('.ad-sidepanel').fadeOut(1000);
            hideAds = true;

        } else if ((footerTop > pageBottom || footerWindowTop >= leftPanelBottom) && hideAds == true) {

            $('.ad-sidepanel').fadeIn(1000);
            hideAds = false;

        }

        //console.log("currentScrollTopPos: " + currentScrollTopPos + " scrollTop: " + triggerScrollTopPos);
        //console.log("pageBottom: " + pageBottom + " footer.offset().top - currentScrollTopPos: " + ( parseInt(footer.offset().top, 10) - currentScrollTopPos ) + " Panel 1 Top Offset: " + (parseInt(leftPanel.offset().top, 10) - currentScrollTopPos) + " Panel 1 Bottom: " + ( parseInt(leftPanel.css('top'), 10) + parseInt(leftPanel.height(), 10) ) ) ;
        //console.log("currentScrollTopPos: " + parseInt(currentScrollTopPos, 10) + " triggerScrollTopPos: " + parseInt(triggerScrollTopPos, 10) + " Panel 1 css top: " + parseInt($('#div-gpt-ad-Panel-Ad-1').css('top'), 10) + " adTopStartPos: " + parseInt(adTopStartPos, 10) + " pageBottom: " + parseInt(pageBottom, 10));
        //console.log("pageBottom: " + pageBottom + " Panel 1 Top: " + parseInt($('#div-gpt-ad-Panel-Ad-1').css('top'), 10) + " footer offset: " + parseInt(footer.offset().top, 10) + " pageBottom: " + pageBottom);
    }
});